import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { HappyCloseGuardService } from './happy-close-guard.service';

export const happyCloseGuard: CanActivateFn = () => inject(HappyCloseGuardService).canActivate();
